import React from 'react';
import { BadgeCheckIcon } from 'lucide-react';
export function GuaranteeBand() {
  return <section aria-label="Guarantee" className="relative overflow-hidden bg-forge-orange" data-id="element-118" data-mp="2uqpcklxt5dwv">
      <div className="absolute inset-0 hatch-dark opacity-20" aria-hidden="true" data-id="element-119" data-mp="2zi7g9hr7tslj" />

      <div className="relative mx-auto flex max-w-8xl items-start gap-5 px-5 py-10 sm:px-8 lg:px-10" data-id="element-120" data-mp="2zkbizwddolk8">
        <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-ink" data-id="element-121" data-mp="26t9xldj3dts9">
          <BadgeCheckIcon className="h-6 w-6 text-forge-orange" aria-hidden="true" data-id="element-122" data-mp="26vmpojikdkj1" />
        </span>
        <div className="min-w-0" data-id="element-123" data-mp="2bu7nyde99u4u">
          <p className="font-mono text-[11.5px] uppercase tracking-[0.18em] text-ink/70" data-id="element-124" data-mp="2ftow5el2h5dp">30-day money-back guarantee</p>
          <h2 className="mt-2 max-w-3xl font-display text-[1.5rem] font-extrabold leading-tight tracking-[-0.01em] text-ink sm:text-[1.85rem]" data-id="element-125" data-mp="2ktuge9p0bplr">
            A clear commitment, backed by a published guarantee.
          </h2>
          <p className="mt-2 max-w-3xl text-[14.5px] font-medium leading-relaxed text-ink/75" data-id="element-126" data-mp="zeso35de0i">
            Within 30 days of purchase, you can request a full refund under WebsiteForge&apos;s published guarantee. That
            gives you time to work with the team and confirm the fit.
            {/* TODO (content): link to the verified production guarantee terms once the URL is confirmed. */}
          </p>
        </div>
      </div>
    </section>;
}